export default __webpack_public_path__ + "static/media/storageUnit1-afterC.7b07c34b.jpg";